import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { MarketDrawerRootReducerState } from '../../../../state/reducer';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { Event } from '../../../../models/calendar';
import { CalendarShowEventAction } from '../../../../state/calendar/actions';
import { DEFAULT_TIMEZONE } from '../../../../services/calendar.service';

@Component({
  selector: 'muni-gameday-calendar-row',
  templateUrl: './calendar-row.template.html',
  styleUrls: ['./calendar-row.styles.scss']
})
export class CalendarRowComponent {
  @Input()
  event: Event;
  @Input()
  current: boolean;

  constructor(private store: Store<MarketDrawerRootReducerState>) {}

  public get formattedReleaseTime(): string {
    return (
      momentTz(this.event.releasedAt)
        .tz(DEFAULT_TIMEZONE)
        .format('h:mm A') + ' ET'
    );
  }

  public get isFuture(): boolean {
    return moment(this.event.releasedAt).isAfter(moment());
  }

  public selectEvent(): void {
    this.store.dispatch(new CalendarShowEventAction(this.event.id));
  }
}
